<template>
    <div  class="mdl-textfield">
        
        <label ref="mdl" class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" > 

            <input ref="checkbox" type="checkbox" class="mdl-checkbox__input" v-model="checked"> 
            
            <span class="mdl-checkbox__label" style="margin-left:-5px;">{{label}}</span>

        </label>
    </div>
</template>

<script>
import mdl from '~/mixins/mdl';
export default {
    name: 'XCheckbox', 
    mixins : [mdl],
    computed: {
        checked:{
            get() {
                return !!this.$data._value
            },
            set(v){
                this.$data._value = !!v ? 1 : 0
                this.$emit('input', this.$data._value)
            }
        }
    },
    methods:{
        setData() {
            this.checked = this.value
            this.$nextTick(()=> {
                this.checked ? 
                this.$refs['mdl'].MaterialCheckbox.check() : 
                this.$refs['mdl'].MaterialCheckbox.uncheck()
            })
        },
    },
    mounted(){
        componentHandler.upgradeElement(this.$refs['mdl'])
    },
    beforeDestroy(){
        componentHandler.downgradeElements(this.$refs['mdl'])
    },
}
</script>
